/**
 * Bytem intelligent recommendation (ported from oldTheme increase_shopify.js / cart-drawer.js).
 * Requires: jQuery, jQuery.cookie, rivets (vendor.min.js), bytem-deps.js
 */
(function () {
  if (typeof rivets === 'undefined') return;

  rivets.formatters.gt = function (value, arg) {
    return value > arg;
  };

  rivets.formatters.showLinePrice = function (item) {
    var gt15 = ((item.real_price - item.sale_price) * 100) / item.real_price;
    return item.real_price > item.sale_price && gt15 >= 15;
  };

  function moneyWithoutDecimals(m) {
    if (typeof m !== 'number') return '0';
    if ((m / 100).toFixed(0) == m / 100) return (m / 100).toFixed(0);
    return (m / 100).toFixed(2);
  }

  rivets.formatters.widthoutDecimals = function (value) {
    return '<span class="money">$' + moneyWithoutDecimals(value) + '</span>';
  };

  rivets.formatters.formatImageSize = function (a, b) {
    if (!a) return 'https://cdn.shopify.com/s/images/admin/no-image-large.gif';
    if (!b) return a;
    return a.indexOf('?') > -1 ? a + '&width=' + b : a + '?width=' + b;
  };

  rivets.components['product-grid'] = {
    static: ['icon', 'sidecart'],
    initialize: function (el, data) {
      return data;
    },
    template: function () {
      var imgSize = screenWidth > 766 ? '600' : '360';
      var shopName = (theme && theme.shop_name) || '';
      var enableSkushop = theme && theme.enable_skushop;
      return (
        '<div class="ajax-product request-list-item" rv-data-spu="product.spuId" rv-data-handle="product.handle" rv-data-id="product.sku" rv-data-name="product.name" rv-data-category="product.type" rv-data-price="product.ga_price" rv-data-compare-to-price="product.compare_to_price" data-brand="' +
        shopName +
        '" data-quantity="1">' +
        '<div class="ajax-product-img">' +
        '<a class="ajax-product-href request-list-item-link" rv-href="product.href">' +
        '<img loading="lazy" rv-src="product.image | formatImageSize ' +
        imgSize +
        '" />' +
        '</a>' +
        (enableSkushop
          ? '<a class="skuShop" rv-data-href="product.dataHref" href="javascript: void(0);" rel="nofollow"><img rv-src="icon" /></a>'
          : '') +
        '</div>' +
        '<div class="ajax-product-message">' +
        '<a rv-unless="sidecart" class="ajax-product-title request-list-item-link" rv-text="product.title" rv-href="product.href"></a>' +
        '<div class="ajax-product-price" rv-if="product | showLinePrice">' +
        '<s rv-html="product.real_price | widthoutDecimals"></s>' +
        '<span rv-html="product.sale_price | widthoutDecimals"></span>' +
        '<div style="flex: 1;"></div>' +
        '<div rv-if="product.showtag" class="grid-view-item__tag">{product.showtag}</div>' +
        '</div>' +
        '<div class="ajax-product-sale" rv-unless="product | showLinePrice">' +
        '<span rv-html="product.sale_price | widthoutDecimals"></span>' +
        '<div style="flex: 1;"></div>' +
        '<div rv-if="product.showtag" class="grid-view-item__tag">{product.showtag}</div>' +
        '</div>' +
        '<div class="ajax-product-color"></div>' +
        '</div>' +
        '</div>'
      );
    },
  };

  /**
   * Product page / wishlist: /musthave/display
   */
  (function () {
    function likeProduct(scene, spuIds) {
      if (!$('[rivet-recommended-product]').length) return;
      this.initRivet();
      if (scene === 'detail') {
        this.likeParam = {
          pageNo: 1,
          pageSize: 32,
          isLoadMore: true,
          scene: scene,
          tempUserId: $.cookie('as_shopify_id'),
          bytemUid: localStorage.getItem('ahaselected/cly_cookie'),
          platform: screenWidth < 766 ? 'm' : 'pc',
          spuIds: spuIds || [],
        };
        this.likeList();
      }
    }

    likeProduct.prototype = {
      initRivet: function () {
        this.ProductRecommended = rivets.bind($('[rivet-recommended-product]'), {
          products: [],
          count: 0,
          loading: false,
        });
      },
      likeList: function () {
        var $this = this;
        $this.ProductRecommended.models.loading = true;
        $this.ProductRecommended.models.products = [];
        AjaxApi('/musthave/display', $this.likeParam, 'POST')
          .then(function (res) {
            var products = (res.entry || []).map(function (v) {
              var marks = v.marks;
              var showtag = (marks || []).includes('Recycled') ? 'Recycled' : '';
              var locale = (Shopify.locale || 'en').toUpperCase();
              var root = (Shopify.routes && Shopify.routes.root) || '/';
              v.href = root + 'products/' + v.handle;
              v.dataHref = root + 'products/' + v.handle + '?view=sku';
              v.real_price = v.originalPrice;
              v.sale_price = v.price;
              v.type = v.productType;
              v.name = v.skuVOList && v.skuVOList.length > 0 ? v.skuVOList[0].name : v.title;
              v.sku = v.skuVOList && v.skuVOList.length > 0 ? v.skuVOList[0].sku : '';
              v.ga_price = (v.price / 100).toFixed(2);
              v.compare_to_price = (v.originalPrice / 100).toFixed(2);
              v.showtag = showtag;
              v.title = Shopify.locale == 'en' ? v.title : v['title' + locale] || v.title;
              return v;
            });

            $this.ProductRecommended.models.loading = false;
            $this.ProductRecommended.models.count = res.count;
            var surplus = 0;
            if (products.length > 4) {
              if (screenWidth < 766) {
                surplus = products.length % 2;
              } else if (screenWidth > 1024) {
                surplus = products.length % 4;
              } else {
                surplus = products.length % 3;
              }
            }
            if (surplus > 0) {
              products.splice(0 - surplus);
            }
            $this.ProductRecommended.models.products = products;
            if (products.length > 0) {
              productGridSku({
                pClass: '.recommended-product-content-list',
                products: products,
              });
            }
          })
          .fail(function () {
            $this.ProductRecommended.models.loading = false;
          });
      },
    };

    if (theme.template_name === 'product') {
      var spuIds = $('#first_product_id').val();
      new likeProduct('detail', [spuIds]);
    }
  })();

  /**
   * Homepage: /musthave/recForMainPage
   */
  (function () {
    function byTem() {
      this.likeParam = {
        pageNo: 1,
        pageSize: 12,
      };
      this.loadFinished = false;
      this.btn_type = $('.apm-btn-type').data('btn-type');
      this.initData();
    }

    byTem.prototype = {
      initData: function () {
        if (!$('[rivet-ajax-load-more]').length) return;
        if (this.btn_type === 'infinite') {
          $(document).scroll(throttle(this.loadMore.bind(this), 300));
        }
        this.initRivet();
        this.loadData();
        if (this.btn_type === 'button') {
          this.clickLoadMore();
        }
      },
      initRivet: function () {
        this.AjaxLoadMore = rivets.bind($('[rivet-ajax-load-more]'), {
          products: [],
          count: 0,
          loading: false,
        });
      },
      isAhaScrollRestoration: function (type) {
        if ('scrollRestoration' in history) {
          history.scrollRestoration = type;
        }
      },
      womenToGoods: function () {
        if (theme.template_name == 'index' && $('.ajax-product-more').length > 0) {
          var referrer = document.referrer;
          var hour_24 = !$.cookie('as_shopify_women_to_goods');
          if (window.is_old_user && hour_24 && referrer.indexOf('ahaselected.com') < 0) {
            var recommendForYou = $('.ajax-product-more').offset().top;
            var header = $('.header-wrapper, #header, header').first().outerHeight() || 0;
            var title = $('.ajax-product-more .new-com-title').outerHeight(true) || 0;
            this.isAhaScrollRestoration('manual');
            $('html,body').animate(
              {
                scrollTop: recommendForYou - header - title,
              },
              0
            );
            $.cookie('as_shopify_women_to_goods', 1, { expires: 1, path: '/' });
          }
        }
      },
      loadData: function () {
        var $this = this;
        this.AjaxLoadMore.models.loading = true;
        AjaxApi(
          '/musthave/recForMainPage',
          Object.assign({}, this.likeParam, {
            tid: '2',
            tempUserId: $.cookie('as_shopify_id'),
            bytemUid: localStorage.getItem('ahaselected/cly_cookie'),
            platform: screenWidth < 766 ? 'm' : 'pc',
          }),
          'POST'
        ).then(function (res) {
          var products = (res.entry || []).map(function (v) {
            var marks = v.marks;
            var showtag = (marks || []).includes('Recycled') ? 'Recycled' : '';
            v.href = '/products/' + v.handle;
            v.dataHref = '/products/' + v.handle + '?view=sku';
            v.real_price = v.originalPrice;
            v.sale_price = v.price;
            v.type = v.productType;
            v.name = v.skuVOList && v.skuVOList.length > 0 ? v.skuVOList[0].name : v.title;
            v.sku = v.skuVOList && v.skuVOList.length > 0 ? v.skuVOList[0].sku : '';
            v.ga_price = (v.price / 100).toFixed(2);
            v.compare_to_price = (v.originalPrice / 100).toFixed(2);
            v.showtag = showtag;
            return v;
          });
          $this.AjaxLoadMore.models.loading = false;
          $this.AjaxLoadMore.models.products = $this.AjaxLoadMore.models.products.concat(products);
          $this.AjaxLoadMore.models.count = $this.AjaxLoadMore.models.count + products.length;
          $this.loadFinished = true;
          if ($this.likeParam.pageNo === 1) {
            $this.womenToGoods();
          }
          if (products.length > 0) {
            $this.likeParam.pageNo++;
            $this.loadFinished = false;
            productGridSku({
              pClass: '.ajax-product-more',
              products: products,
            });
          } else {
            $this.loadFinished = true;
            $('.ajax-product-more .ajax-product-more-loading').remove();
            $('.ajax-product-more .apm-btn').remove();
          }
          $('body').removeClass('loading hideOverly');
        });
      },
      loadMore: function () {
        if (this.AjaxLoadMore.models.loading) return;
        if (this.loadFinished) return;
        var rect = $('[rivet-ajax-load-more]')[0].getBoundingClientRect();
        if (rect.bottom < (window.innerHeight || document.documentElement.clientHeight) + 290) {
          this.loadData();
        }
      },
      clickLoadMore: function () {
        var $this = this;
        $('.ajax-product-more').on('click', '.apm-btn', function () {
          $('body').addClass('loading hideOverly');
          $this.loadMore();
        });
        $('.ajax-product-more').on('click', '.ajax-product-color', function () {
          var handle = $(this).parents('.ajax-product').data('handle');
          window.location.href = '/products/' + handle;
        });
      },
    };

    if ($('.ajax-product-more').length === 1) {
      new byTem();
    }
  })();

  /**
   * Cart drawer: /musthave/recForCart
   */
  (function () {
    var cartIconUrl =
      (window.theme && theme.bytemCartIcon) ||
      'https://cdn.shopify.com/s/files/1/0605/4880/8939/files/cart-icon_72x.png';

    var state = {
      preId: '',
      cartRecommend: [],
    };

    function widthoutDecimals(value) {
      return '<span class="money">$' + moneyWithoutDecimals(value) + '</span>';
    }

    function createCartRecommendHtml(lists) {
      var htmlString = '';
      for (var i = 0; i < (lists || []).length; i++) {
        var list = lists[i];
        var priceHtml = '<span class="cart-drawer-product__sale">' + widthoutDecimals(list.price) + '</span>';
        if (list.originalPrice > list.price) {
          priceHtml =
            '<s class="cart-drawer-product__original">' +
            widthoutDecimals(list.originalPrice) +
            '</s><span class="cart-drawer-product__price_sale">' +
            widthoutDecimals(list.price) +
            '</span>';
        }
        var root = (Shopify.routes && Shopify.routes.root) || '/';
        var imgSrc = list.image || '';
        if (imgSrc && imgSrc.indexOf('width=') === -1) {
          imgSrc = imgSrc.indexOf('?') > -1 ? imgSrc + '&width=240' : imgSrc + '?width=240';
        }
        htmlString +=
          '<li class="cart-drawer-product request-list-item" data-id="' +
          (list.sku || '') +
          '" data-handle="' +
          list.handle +
          '">' +
          '<div class="cart-drawer-product__image">' +
          '<img class="cart-drawer-product__img" loading="lazy" src="' +
          imgSrc +
          '" />' +
          '<a class="cart-drawer-product__link request-list-item-link" href="' +
          root +
          'products/' +
          list.handle +
          '"></a>' +
          '<a class="cart-drawer-product__quick" href="' +
          root +
          'products/' +
          list.handle +
          '">' +
          '<img width="20" height="20" src="' +
          cartIconUrl +
          '" alt="" />' +
          '</a>' +
          '</div>' +
          '<div class="cart-drawer-product__price">' +
          priceHtml +
          '</div>' +
          '</li>';
      }
      $('.cart-drawer-products').html(htmlString);
      $('.cart-drawer-recommended__title').show();
      if (htmlString) {
        $('.cart-drawer-recommended').removeClass('hide');
      } else {
        $('.cart-drawer-recommended').addClass('hide');
      }
    }

    function updateCartRecommend(parsedState) {
      if (!$('.cart-drawer-recommended').length) return;
      var items = (parsedState && parsedState.items) || [];
      var _items = items.filter(function (item) {
        return !(item.properties && (item.properties._gift || item.properties.isGift === 'true'));
      });
      if (!_items.length) {
        $('.cart-drawer-products').empty();
        $('.cart-drawer-recommended').addClass('hide');
        state.preId = '';
        state.cartRecommend = [];
        return;
      }
      var cartSpuIds = _items.map(function (item) {
        return item.product_id;
      });
      var pid = cartSpuIds[0];
      if (state.preId == pid) {
        createCartRecommendHtml(state.cartRecommend);
        return;
      }
      $('.cart-drawer-recommended__loading').show();
      AjaxApi(
        '/musthave/recForCart',
        {
          pid: pid,
          cartSpuIds: cartSpuIds,
          tempUserId: $.cookie('as_shopify_id'),
          bytemUid: localStorage.getItem('ahaselected/cly_cookie'),
          platform: screenWidth < 766 ? 'm' : 'pc',
        },
        'POST'
      )
        .then(function (res) {
          var lists = (res.entry || []).map(function (list) {
            list.sku = list.skuVOList && list.skuVOList.length > 0 ? list.skuVOList[0].sku : '';
            return list;
          });
          lists = lists.length > 12 ? lists.splice(0, 12) : lists;
          createCartRecommendHtml(lists);
          state.preId = pid;
          state.cartRecommend = lists;
        })
        .always(function () {
          $('.cart-drawer-recommended__loading').hide();
        });
    }

    function initCartData() {
      if (!$('.cart-drawer-recommended').length) return;
      fetch((window.Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (parsedState) {
          updateCartRecommend(parsedState);
        })
        .catch(function () {});
    }

    function bindCartUpdates() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          // Section re-render wipes recommend DOM; refill after paint.
          setTimeout(initCartData, 300);
        });
      }
      document.addEventListener('cart:updated', function () {
        setTimeout(initCartData, 300);
      });
    }

    initCartData();
    bindCartUpdates();
    window.BytemCartRecommend = {
      update: updateCartRecommend,
      refresh: initCartData,
    };
  })();
})();
